import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export default function Protected({ children, ...rest }) {
  const isLoggedIn = localStorage && localStorage.getItem('token');

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
